import { Component, OnInit } from '@angular/core';
import { LocalizationService } from '../../services/localization.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-pwa-install-guide-modal',
    templateUrl: './pwa-install-guide-modal.component.html',
    styleUrls: ['./pwa-install-guide-modal.component.scss'],
    standalone: false
})
export class PwaInstallGuideModalComponent implements OnInit {

    constructor(private localizationService:LocalizationService, private activeModal:NgbActiveModal) { }

    currentLanguage:string = null;

    currentSection:'desktop'|'mobile'|'faq' = 'desktop'

    ngOnInit(): void {
        this.currentLanguage = this.localizationService.currentLanguage;

        if(this._isMobileDevice()) this.currentSection = 'mobile'
    }

    private _isMobileDevice() {
        if (typeof window === 'undefined') return false; // Sicurezza per SSR (Server-Side Rendering)

        // 1. Controllo moderno basato sulle caratteristiche fisiche (Pointer/Touch)
        // 'coarse' indica un puntatore impreciso come il dito su uno schermo touch (smartphone/tablet)
        const isTouchPrimary = window.matchMedia('(pointer: coarse)').matches;

        // 2. Controllo dell'User-Agent classico per sicurezza
        const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
        const isMobileUA = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

        // 3. Controllo specifico per iPadOS (che si finge macOS)
        const isIPadOS = /Macintosh/.test(userAgent) && navigator.maxTouchPoints > 1;

        return isTouchPrimary || isMobileUA || isIPadOS;
    };

    dismissModal() {
        this.activeModal.dismiss()
    }
}
